import React, { useEffect } from "react";
import { useLang, applyHomeSeo } from "@/lib/i18n";
import Nav from "@/components/berlin/Nav";
import Hero from "@/components/berlin/Hero";
import Definition from "@/components/berlin/Definition";
import Realisiert from "@/components/berlin/Realisiert";
import Vorfuehrung from "@/components/berlin/Vorfuehrung";
import Manifest from "@/components/berlin/Manifest";
import Today from "@/components/berlin/Today";
import Transformation from "@/components/berlin/Transformation";
import Weg from "@/components/berlin/Weg";
import CitiesChange from "@/components/berlin/CitiesChange";
import Challenges from "@/components/berlin/Challenges";
import Impact from "@/components/berlin/Impact";
import Collection from "@/components/berlin/Collection";
import Gallery from "@/components/berlin/Gallery";
import VisionBerlin from "@/components/berlin/Pilot";
import Technology from "@/components/berlin/Technology";
import Financing from "@/components/berlin/Financing";
import Europe from "@/components/berlin/Europe";
import Anwendungen from "@/components/berlin/Anwendungen";
import HomeFaq from "@/components/berlin/HomeFaq";
import PresseMedien from "@/components/berlin/PresseMedien";
import AktuellesTeaser from "@/components/berlin/AktuellesTeaser";
import CTA from "@/components/berlin/CTA";
import Footer from "@/components/berlin/Footer";

export default function Landing() {
  const { lang } = useLang();

  useEffect(() => {
    applyHomeSeo(lang);
  }, [lang]);

  useEffect(() => {
    const h = window.location.hash;
    if (h) {
      setTimeout(() => document.querySelector(h)?.scrollIntoView({ behavior: "smooth" }), 700);
    }
  }, []);
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#1F2328] text-white">
      <Nav />
      <main>
        <Hero />
        {/* Definitionssatz — erster Fließtext direkt unter dem Hero */}
        <Definition />
        {/* AKT I — Realisiert: echte Fotos Kantstraße, vor allen Visualisierungen */}
        <Realisiert />
        {/* Vorführung — temporärer Aufbau, Outlet-Center Brandenburg */}
        <Vorfuehrung />
        {/* V2.1 · P4 — Manifest: BERLIN ─ CUBE ist kein Poller */}
        <Manifest />
        {/* V2.1 · P2 — HEUTE (Ist-Zustand, echte Fotos benötigt) */}
        <Today />
        {/* V2.1 · P3 — TRANSFORMATION Vorher/Nachher Slider */}
        <Transformation />
        {/* Der Weg dorthin — Zeitstrahl (Rest der aufgelösten Sektion pilot-berlin) */}
        <Weg />
        {/* Kontext — Städte verändern sich */}
        <CitiesChange />
        {/* V2.1 · P5 — Herausforderungen als Hauptanker */}
        <Challenges />
        {/* V2.1 · P6 — Impact-Matrix */}
        <Impact />
        {/* Plattform · Collection — kompakter Intro + 9 Module (Straffung 18.07.2026) */}
        <Collection />
        <Gallery />
        {/* Vision Berlin */}
        <VisionBerlin />
        {/* Technologie */}
        <Technology />
        {/* Finanzierung */}
        <Financing />
        {/* Europa */}
        <Europe />
        {/* Anwendungen — interne Verlinkung Landingpages */}
        <Anwendungen />
        {/* FAQ — Fragen aus Kommunen */}
        <HomeFaq />
        {/* Presse — Medienspiegel */}
        <PresseMedien />
        {/* Kontakt */}
        <CTA />
        {/* Aktuelles — Teaser neuester Beitrag */}
        <AktuellesTeaser />
      </main>
      <Footer />
    </div>
  );
}
